import { createSelector } from 'reselect';
import { subselect } from './root';

export const isChatSoonVisibleSelector = createSelector(
  [(chatDialogs) => chatDialogs.showChatSoon],
  (value) => !!value,
);

export const chatDialogsIsChatSoonVisibleSelector = subselect(isChatSoonVisibleSelector);
